<template>
  <q-page>
    <div class="q-pa-md">
      <div class="row q-col-gutter-md q-mb-md">
        <div class="col-9">
          <div class="row">
            <div class="page-title q-mr-sm">Action Templates</div>
            <div>
              <q-btn
                color="primary"
                :loading="isLoading"
                class="float-right sustainability-button"
                @click="add"
              >
                <q-icon name="mdi-plus-circle"> </q-icon>
                <span
                  class="sustainability-font q-mx-sm"
                  style="font-size: 13px"
                >
                  Add
                </span>
              </q-btn>
            </div>
          </div>
        </div>
        <div class="col-3">
          <q-input
            class="searchbar float-right"
            style="max-width: 70%"
            filled
            v-model="searchText"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"></q-icon>
            </template>
          </q-input>
        </div>
      </div>
      <div class="row">
        <q-card class="full-width">
          <sustainability-data-table
            flat
            headerBgColor="#162c47"
            headerTextColor="white"
            :filter="searchText"
            :columns="columns"
            :data="data"
            @rowDoubleClick="onRowDoubleClick"
          >
          </sustainability-data-table>
        </q-card>
      </div>
    </div>
    <q-dialog persistent v-model="dialog" full-height full-width>
      <action-templates-form> </action-templates-form>
    </q-dialog>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import ActionTemplatesForm from "@/components/actionTemplates/actionTemplatesForm.vue";
  import SustainabilityDataTable from "@/components/datatable/sustainabilityDatatable.vue";
  export default {
    data: () => ({
      searchText: "",
      dialog: false,
      isLoading: false,
    }),
    components: {
      SustainabilityDataTable,
      ActionTemplatesForm,
    },
    computed: {
      ...mapGetters({
        data: "actionTemplates/list",
      }),
      dataGridCSS() {
        return [
          'font-family: "Montserrat";',
          "font-style: normal;",
          "font-weight: 400;",
          "font-size: 14px;",
          "line-height: 13px;",
        ].join(";");
      },
      columns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 60px;max-width: 60px;width: 60px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" +
              this.dataGridCSS,
            sortable: true,
          },
          {
            name: "name",
            label: "Name",
            align: "left",
            field: "name",
            style:
              "min-width: 200px;max-width: 200px;width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" +
              this.dataGridCSS,
            sortable: true,
          },
          {
            name: "templateValue",
            label: "Template",
            align: "left",
            field: "templateValue",
            style:
              "min-width: 300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" +
              this.dataGridCSS,
            sortable: true,
          },
        ];
      },
    },
    mounted() {
      this.$store.dispatch("actionTemplates/loadAll");
      this.handleRoute();
    },

    watch: {
      $route: function () {
        this.handleRoute();
      },
      dialog: function () {
        console.log(this.dialog);
      },
    },
    methods: {
      onRowDoubleClick(row) {
        this.$router.push(`${this.$route.path}/${row.id}`);
        // this.$router.push("/units/" + row.id);
      },
      handleRoute() {
        if (this.$route.params.hasOwnProperty("actionTemplates_id")) {
          this.dialog = true;
        } else {
          this.dialog = false;
        }
      },
      async add() {
        this.isLoading = true;
        let result = await this.$store.dispatch("actionTemplates/new", {
          // status: "temp",
        });
        this.$router.push(`${this.$route.path}/${result.Response.ID}`);
        this.isLoading = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .page-title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
  }
  .sustainability-button {
    height: 34px;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 9px;
    line-height: 11px;
    display: flex;
    align-items: center;
    text-align: center;
  }
</style>
